import './button.scss'

const initButtonAnchorScroll = () => {
	const links = document.querySelectorAll(
		'a.a-button[href^="#"]'
	);

	if ( ! links.length ) {
		return;
	}

	links.forEach( ( link ) => {
		link.addEventListener( 'click', ( event ) => {
			const href = link.getAttribute( 'href' );

			if ( ! href || href.charAt( 0 ) !== '#' || href.length < 2 ) {
				return;
			}

			const target_id = href.slice( 1 );
			const target = document.getElementById( target_id );

			if ( ! target ) {
				return;
			}

			event.preventDefault();

			const previous_tabindex = target.getAttribute( 'tabindex' );

			if ( previous_tabindex === null ) {
				target.setAttribute( 'tabindex', '-1' );
			}

			target.scrollIntoView( {
				behavior: 'smooth',
				block: 'start',
			} );

			try {
				target.focus( {
					preventScroll: true,
				} );
			} catch ( e ) {
				// focus options not supported; ignore.
			}

			if ( previous_tabindex === null ) {
				target.removeAttribute( 'tabindex' );
			}
		} );
	} );
};

if ( document.readyState === 'loading' ) {
	document.addEventListener(
		'DOMContentLoaded',
		initButtonAnchorScroll
	);
} else {
	initButtonAnchorScroll();
}